import { render, staticRenderFns } from "./AddFamilyLevelDialog.vue?vue&type=template&id=2c4536a4&scoped=true"
import script from "./AddFamilyLevelDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AddFamilyLevelDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AddFamilyLevelDialog.vue?vue&type=style&index=0&id=2c4536a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4536a4",
  null
  
)

export default component.exports